import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ComponentCard from "../../../components/common/ComponentCard";
import Label from "../../../components/form/Label";
import Select from "../../../components/form/Select";
import Button from "../../../components/ui/button/Button";
import Form from "../../../components/form/Form";
import { CalenderIcon } from "../../../icons";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import { jwtDecode } from "jwt-decode";

export default function AddInspectionHistory() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const[inspectionTypes, setInspectionTypes] = useState<any[]>([]);
  const[venues, setVenues] = useState<any[]>([]);
  const [inspectors, setInspectors] = useState<any[]>([]);
  const [venueAreas, setVenueAreas] = useState<any[]>([]);

  const decoded: any = jwtDecode(token || "");
  const venueId = decoded?.cst;
  const navigate = useNavigate();
  // const [inspectionDate, setinspectionDate] = useState("");

  const [errors, setErrors] = useState({
    inspectionDate: "",
  });

  const [filters, setFilters] = useState({
    inspectionDate: "",
  });

  const [formData, setFormData] = useState({
    inspectionDate: "",
    inspectionTypeId: "",
    inspectorId: "",
    venueId: "",
    venueAreaId: "",
    autorenew: "",
    periodtype: "",
  });

  // Fetch Venues by admin user
  const fetchVenues = async () => {
    try {
      const response = await fetch(`${apiUrl}/inspection_history/venues`, { 
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
      });
      const result = await response.json();
      
      if(result.success){
        setVenues(result.venues);
      }else{
        setVenues([]);
      }
      // Handle the fetched data as needed
    } catch (error) {
      console.error("Error fetching venues:", error);
    }
  };

  useEffect(() => {
  fetchVenues();
  }, []);

  // Fetch inspection types By Venue
  const fetchInspectionTypes = async (venueId: number) => {

    try{
      const response = await fetch(`${apiUrl}/inspection_types/${venueId}`, {
        headers: { token: token || "" },
      });
      const result = await response.json();

      if(result.success){
        setInspectionTypes(result.inspType);
      }else{
        setInspectionTypes([]);
      }
    }catch(err){
      console.error("Error fetching inspection types:", err);
    }
  }

  useEffect(() => {
    fetchInspectionTypes(venueId);
  }, []);

  // Fetch inspectors by Venue
  const fetchInspectors = async (venueId: number) => {
    try {
      const response = await fetch(`${apiUrl}/inspection_history/${venueId}`, {
        headers: { token: token || "" },
      });
      const inspectors = await response.json();

      if(inspectors.success){
        setInspectors(inspectors.inspector);
      }else{
        setInspectors([]);
      }

    } catch (err) {
      console.error("Error fetching related data:", err);
    }
  };

  useEffect(() => {
    fetchInspectors(venueId);
  }, []);


  //Fetch Venue Areas by Venue
  const fetchVenueAreas = async () => {
    try {
      const response = await fetch(`${apiUrl}/venue_area`, {
        headers: { token: token || "" },
      });
      const result = await response.json();

      if(result.success){
        setVenueAreas(result.venueAreas);
      }else{
        setVenueAreas([]);
      }
    } catch (err) {
      console.error("Error fetching venue areas:", err);
    }
  };

  useEffect(() => {
    fetchVenueAreas();
  }, []);

  const formatDateAsLocalYmd = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDateChange = (date: Date[]) => {
    if (date.length > 0) {
      const formattedDate = formatDateAsLocalYmd(date[0]);
      setFormData(prev => ({
        ...prev,
        inspectionDate: formattedDate,
      }));
    }
  };

  const handleSelectChange = (field: string, value: string) => {
    // If user selected Inspection Type
    if (field === "inspectionTypeId") {
      const selectedType = inspectionTypes.find(
        (item) => item.inspectiontype_id === Number(value)
      );

      setFormData(prev => ({
        ...prev,
        inspectionTypeId: value,
        autorenew: selectedType?.autorenew || "",
        periodtype: selectedType?.periodtype || "",
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await fetch(`${apiUrl}/inspection_history`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        navigate("/inspections-history");
      } else {
        alert(result.message || "Failed to add inspection history");
      }
    } catch (err) {
      console.error("Error submitting inspection history:", err);
    }
  };


  const handleCancel = () => {
    navigate("/inspections-history");
  };

  return(
    <>
      <ComponentCard title="Add New Inspection Type">
        <Form onSubmit={handleSubmit}>
          <div className="grid gap-6">
            <div className="grid grid-cols-1 gap-6 xl:grid-cols-2"></div>
            <div className="col-span-full">
              <h4 className="pb-4 text-base font-medium text-gray-800 border-b border-gray-200 dark:border-gray-800 dark:text-white/90">
                Inspection Type Details
              </h4>
            </div>
            <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
              <div className="space-y-6">
                <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
                  <div className="space-y-4">
                    <Label htmlFor="lastName">Inspection Date</Label>
                    <div className="relative flatpickr-wrapper w-fit">
                      <Flatpickr
                        onChange={handleDateChange}
                        options={{
                          dateFormat: "d-m-Y",
                        }}
                        className="w-full py-2 pl-3 pr-10 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-800 dark:border-gray-700 dark:text-white"
                      />
                      <span className="absolute text-gray-500 -translate-y-1/2 pointer-events-none right-3 top-1/2 dark:text-gray-400">
                        <CalenderIcon />
                      </span>
                    </div>
                    <div>
                      <Label>Inspection Type</Label>
                      <Select
                        options={inspectionTypes.map(data => ({
                          key: data.inspectiontype_id,
                          value: data.inspectiontype_id,
                          label: data.name,
                        }))}
                        
                        onChange={(value) => handleSelectChange("inspectionTypeId", value)}
                        className="mt-2 bg-gray-50 dark:bg-gray-800"
                      />
                    </div>
                    <div>
                      <Label>Inspector</Label>
                      <Select
                        options={inspectors.map(data => ({
                          key: data.user_id,
                          value: data.user_id,
                          label: data.name,
                        }))}
                        onChange={(value) => handleSelectChange("inspectorId", value)}
                        className="mt-2 bg-gray-50 dark:bg-gray-800"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-6">
                <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-gray-900">
                  <div className="space-y-4">
                    <div>
                      <Label>Venue</Label>
                      <Select
                        options={venues.map(venue => ({
                          key: venue.cst,
                          value: venue.cst,
                          label: venue.name,
                        }))}
                        onChange={(value) => handleSelectChange("venueId", value)}
                        className="mt-2 bg-gray-50 dark:bg-gray-800"
                      />
                    </div>
                    <div>
                      <Label>Venue Area</Label>
                      <Select
                        options={venueAreas.map(venuesAreas => ({
                          key: venuesAreas.venuearea_id,
                          value: venuesAreas.venuearea_id,
                          label: venuesAreas.name,
                        }))}
                        onChange={(value) => handleSelectChange("venueAreaId", value)}
                        className="mt-2 bg-gray-50 dark:bg-gray-800"
                      />
                    </div>
                  </div>
                </div>
                {/* Buttons */}
                <div className="flex gap-2 mt-2">
                  <Button type="submit" size="sm">
                    Save Changes
                  </Button>
                  <Button type="button"  size="sm" variant="outline" onClick={handleCancel}>
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </ComponentCard>
    </>  
  )
}
